import type { ApiClient } from "@/clients/ApiClient";
import { fromEither } from "./compat";

export interface CategoriesApi {
    list(): Promise<Category[]>;
    /** The category with all its podcasts */
    get(id: number): Promise<Category>;
    episodes(id: number, page: number): Promise<Episode[]>;
    /** The podcasts of the category that are in today's toplist, best first */
    toplist(id: number): Promise<Podcast[]>;
}

// The Go API leaves out empty text fields, the pages read them as strings
const normalize = (category: Category): Category => ({
    ...category,
    content: category.content ?? "",
    art: category.art ?? "",
});

export const createCategoriesApi = (client: ApiClient): CategoriesApi => ({
    async list() {
        const categories = fromEither<Category[]>(await client.get("/categories"), "categories");
        return categories.map(normalize);
    },

    async get(id) {
        return normalize(fromEither<Category>(await client.get(`/categories/${id}`), "category"));
    },

    async episodes(id, page) {
        return fromEither<Episode[]>(await client.get(`/categories/${id}/episodes?page=${page}`), "episodes");
    },

    async toplist(id) {
        const entries = fromEither<ToplistEntry[]>(await client.get(`/categories/${id}/toplist`), "entries");
        return entries.map((entry) => entry.podcast).filter((podcast): podcast is Podcast => podcast !== undefined);
    },
});
